import { ref, uploadBytes } from "firebase/storage";
import { useRef, useState } from "react";
import * as Sentry from "@sentry/react";
import { storage } from "../api/firebaseApi";
import { createUniqueFileForUpload } from "../helpers/file_helpers";

export const useAddFileToDB = () => {
  const [isLoadingAddFile, setIsLoadingAddFile] = useState(false);
  const fileRef = useRef<HTMLInputElement | null>(null);

  const onSubmitAddFile = async (
    file: File,
    path: string,
    allowOverwrite = false
  ) => {
    let result;
    if (allowOverwrite) {
      // Directly use the provided path without renaming
      result = { file, path };
    } else {
      // Rename the file to guarantee existing files aren't accidentally overwritten
      result = await createUniqueFileForUpload(path, file);
    }

    const imageRef = ref(storage, result.path);
    setIsLoadingAddFile(true);

    try {
      await uploadBytes(imageRef, result.file);
    } catch (error) {
      Sentry.captureException(error);
    } finally {
      setIsLoadingAddFile(false);
    }
    return { file: result.file, path: result.path };
  };

  return {
    isLoadingAddFile,
    fileRef,
    onSubmitAddFile
  };
};
